<div class="full-height layout-column">

  <!--Table Skeleton, shown only until the services have loaded for the first time-->
  <div *ngIf="!isInitialized" class="flex layout-column bringoz-table bringoz-table-skeleton fade-element-in-only">

    <div class="layout-row layout-align-start-center tr-header">
      <div class="th skeleton-col-checkbox"></div>
      <div class="th skeleton-col-lg"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-lg"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-sm"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
      <div class="th skeleton-col-md"><div class="bringoz-skeleton bringoz-skeleton-text"></div></div>
    </div>

    <div class="layout-row layout-align-start-center tr" *ngFor="let row of skeletonRows">
      <div class="td skeleton-col-checkbox">
        <div class="bringoz-skeleton skeleton-checkbox"></div>
      </div>
      <div class="td skeleton-col-lg layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 80%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 55%"></div>
      </div>
      <div class="td skeleton-col-sm layout-row">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 45%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 45%"></div>
      </div>
      <div class="td skeleton-col-md layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 70%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 40%"></div>
      </div>
      <div class="td skeleton-col-sm">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%"></div>
      </div>
      <div class="td skeleton-col-md layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 65%"></div>
      </div>
      <div class="td skeleton-col-lg">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 85%"></div>
      </div>
      <div class="td skeleton-col-sm">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 50%"></div>
      </div>
      <div class="td skeleton-col-md layout-column">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 75%"></div>
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 45%"></div>
      </div>
      <div class="td skeleton-col-md">
        <div class="bringoz-skeleton bringoz-skeleton-text" style="width: 60%"></div>
      </div>
    </div>

  </div>

  <!--Table-->
  <div class="flex layout-column bringoz-table bringoz-table-sticky"
       [hidden]="!isInitialized || !services.length"
       [ngClass]="{'scrollable': isScrollable}">

    <!--Table Headers-->
    <div id="header"
         [hidden]="!!displayAsItems"
         class="layout-row layout-align-start-center tr text-uppercase fade-element-in-only">

      <!--Service-->
      <div class="th sticky layout-row layout-align-start-center
           large flex-15  text-ellipsis text-left">{{'Service' | translate}}</div>

      <!--Order ID-->
      <div *ngIf="columns.orderId" class="th flex small text-ellipsis">{{'Order ID' | translate}}</div>

      <!--Route ID-->
      <div *ngIf="columns.routeId" class="th flex small text-ellipsis">{{'Route ID' | translate}}</div>

      <!--Display Id-->
      <div *ngIf="columns.displayId" class="th flex small text-ellipsis">{{'displayId' | translate}}</div>

      <!--Operational Units-->
      <div *ngIf="columns.operationalUnits" class="th flex small text-ellipsis">{{'Branches' | translate}}</div>

      <!--Agent Operational Units-->
      <div *ngIf="columns.agentOperationalUnits"
           class="th flex small text-ellipsis">{{'DELIVERIES_TABLE_COLUMNS.agentOperationalUnits' | translate}}</div>

      <!--Items Types-->
      <div *ngIf="columns.itemsTypes"
           class="th flex small text-ellipsis">{{'DELIVERIES_TABLE_COLUMNS.itemsTypes' | translate}}</div>

      <!--Items Ids-->
      <div *ngIf="columns.itemsIds"
           class="th flex small text-ellipsis">{{'DELIVERIES_TABLE_COLUMNS.itemsIds' | translate}}</div>

      <!--Items Barcodes -->
      <div *ngIf="columns.itemsBarcodes"
           class="th flex small text-ellipsis">{{'DELIVERIES_TABLE_COLUMNS.itemsBarcodes' | translate}}</div>

      <!--Pallets -->
      <div *ngIf="columns.pallets"
           class="th flex small text-ellipsis">{{'DELIVERIES_TABLE_COLUMNS.pallets' | translate}}</div>

      <!--Resource name -->
      <div *ngIf="columns.resource"
           class="th flex small text-ellipsis">{{'DELIVERIES_TABLE_COLUMNS.resource' | translate}}</div>

      <!--Risks-->
      <div *ngIf="columns.risks" class="th flex small text-ellipsis">{{'Risks' | translate}}</div>

      <!--Invoice-->
      <div *ngIf="columns.invoice" class="th flex small text-ellipsis">{{'Invoice' | translate}}</div>

      <!--Account-->
      <div *ngIf="columns.account"
           class="th flex layout-row layout-align-start-center large text-ellipsis">
        <span>{{'Account' | translate}}</span>

        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortAccountName')">
          <bringoz-icon [iconName]="sortType.name === 'sortAccountName' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>

      </div>

      <!--Carrier-->
      <div *ngIf="columns.carrier"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Supply Account' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortAgentAccountName')">
          <bringoz-icon [iconName]="sortType.name === 'sortAgentAccountName' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>

      </div>

      <!--Agent-->
      <div *ngIf="columns.agent"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Agent' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortAgentName')">
          <bringoz-icon [iconName]="sortType.name === 'sortAgentName' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>

      </div>

      <!--Location-->
      <div *ngIf="columns.location"
           class="th flex-15 layout-row layout-align-start-center large text-ellipsis">
        <span>{{'Location' | translate}}</span>

        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange(sortType.name)">
          <bringoz-icon [iconName]="sortType.name === 'sortLocationPickup' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>


        <bringoz-button type="tertiary"
                        (onClick)="onSortTypeChange('sortLocationPickup')">
          <span [ngClass]="{'pickup': sortType.name === 'sortLocationPickup'}">
            {{'TASK_PURPOSE.P' | translate}}
          </span>
        </bringoz-button>

        <bringoz-button type="tertiary"
                        (onClick)="onSortTypeChange('sortLocationDestination')">
          <span [ngClass]="{'destination': sortType.name === 'sortLocationDestination'}">
            {{'TASK_PURPOSE.D' | translate}}
          </span>
        </bringoz-button>

      </div>

      <!--Task Approval Status-->
      <div *ngIf="columns.taskApprovalStatus"
           class="th flex small text-ellipsis">{{'Approval Status' | translate}}</div>


      <!--Progress-->
      <div *ngIf="columns.progress"
           class="th flex-10 layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Progress' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortProgress')">
          <bringoz-icon [iconName]="sortType.name === 'sortProgress' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>


      <!--Contact-->
      <div *ngIf="columns.contact"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Contact' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortContactName')">
          <bringoz-icon [iconName]="sortType.name === 'sortContactName' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>


      <!--Program Type-->
      <div *ngIf="columns.programType" class="th flex small text-ellipsis">{{'Program Type' | translate}}</div>

      <!--Assigned Date -->
      <div *ngIf="columns.assignedDate" class="th flex small text-ellipsis">{{'DELIVERIES_TABLE_COLUMNS.assignedDate' | translate}}</div>

      <!--ETA-->
      <div *ngIf="columns.eta" class="th flex small text-ellipsis">{{'ETA' | translate}}</div>

      <!--Distance-->
      <div *ngIf="columns.distance"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Distance' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortDistance')">
          <bringoz-icon [iconName]="sortType.name === 'sortDistance' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Service Areas-->
      <div *ngIf="columns.serviceAreas"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Service Areas' | translate}}</span>
      </div>

      <!--Time Window-->
      <div *ngIf="columns.timeWindow"
           class="th flex-15 layout-row layout-align-start-center large text-ellipsis">
        <span>{{'Time Window' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortTimeWindow')">
          <bringoz-icon [iconName]="sortType.name === 'sortTimeWindow' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Urgency-->
      <div *ngIf="columns.urgency"
           class="th flex-5 layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Urgency' | translate}}</span>
      </div>

      <!--Load-->
      <div *ngIf="columns.load && hasFleetManagementPermission"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Load' | translate}}</span>
      </div>


      <!--Price-->
      <div *ngIf="columns.price && hasPricePlanPermission"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Price' | translate}}</span>
      </div>

      <!--Time To Pickup-->
      <div *ngIf="columns.timeToPickup"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Time To Pickup' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortTimeWindow')">
          <bringoz-icon [iconName]="sortType.name === 'sortTimeWindow' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Time To Deliver-->
      <div *ngIf="columns.timeToDeliver"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Time To Deliver' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortTimeWindow')">
          <bringoz-icon [iconName]="sortType.name === 'sortTimeWindow' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Since Created-->
      <div *ngIf="columns.created"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Since Created' | translate}}</span>
        <bringoz-button type="tertiary"
                        (click)="onSortTypeChange('sortCreatedAt')">
          <bringoz-icon [iconName]="sortType.name === 'sortCreatedAt' ?
                        asceDescIconsMap[sortType.type] : 'sort'">
          </bringoz-icon>
        </bringoz-button>
      </div>


      <!--Cancellation Reason-->
      <div *ngIf="columns.actionReason"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'Action Reason' | translate}}</span>
      </div>

      <!--PRO Number-->
      <div *ngIf="columns.proNumber"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'PRO Number' | translate}}</span>
      </div>

      <!--Reference Ids-->
      <div *ngIf="columns.referenceIds"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span>{{'DELIVERIES_TABLE_COLUMNS.referenceIds' | translate}}</span>
      </div>

      <!--Logistics Vehicles-->
      <div *ngIf="columns.logisticsVehicles && hasFleetManagementPermission"
           class="th flex-10 layout-row layout-align-start-center medium text-ellipsis">
        <span>{{'DELIVERIES_TABLE_COLUMNS.logisticsVehicles' | translate}}</span>
      </div>

      <!--Notes-->
      <div *ngIf="columns.notes"
           class="th flex-10 layout-row layout-align-start-center large text-ellipsis">
        <span>{{'DELIVERIES_TABLE_COLUMNS.notes' | translate}}</span>
      </div>

      <!--Special Instructions-->
      <div *ngIf="columns.specialInstructions"
           class="th flex layout-row layout-align-start-center large text-ellipsis">
        <span>{{'DELIVERIES_TABLE_COLUMNS.specialInstructions' | translate}}</span>
      </div>

      <!--POD's-->
      <div *ngIf="columns.pods"
           class="th flex layout-row layout-align-start-center large text-ellipsis">
        <span>{{'DELIVERIES_TABLE_COLUMNS.pods' | translate}}</span>
      </div>

      <!--Dynamic Columns-->
      <div *ngFor="let column of enabledDynamicColumns"
           class="th flex layout-row layout-align-start-center small text-ellipsis">

        <span *ngIf="column.enabled">{{column.title}}</span>
      </div>

      <!--Packages Dynamic Columns-->
      <div *ngFor="let column of enabledPackageDynamicColumns"
           class="th flex layout-row layout-align-start-center small text-ellipsis">
        <span *ngIf="column.enabled">{{column.title}}</span>
      </div>

    </div>

    <!--Table Body-->
    <div class="flex layout-column full-height" [ngClass]="!displayAsItems ? 'rows-container' : ''">

      <!--Repeater-->
      <div class="full-height flex layout-column">
        <cdk-virtual-scroll-viewport [itemSize]="displayAsItems ? 140 : 75" class="flex layout-column"
                                     [ngClass]="{'action-padding': selectedIds.length, 'mobile': !!displayAsItems, 'viewport': !displayAsItems}"
                                     (scroll)="getNextBatch()">

          <ng-container *ngIf="!displayAsItems; else itemsContainer" class="flex layout-column">
            <app-services-table-row *cdkVirtualFor="let service of services; trackBy: trackById"
                                    class="item flex layout-column"
                                    [service]="service"
                                    [isSelected]="selectedKeys[service.id]"
                                    [columns]="columns"
                                    [isDisableActionMenu]="!!selectedIds?.length"
                                    [dynamicColumns]="enabledDynamicColumns"
                                    [packageDynamicColumns]="enabledPackageDynamicColumns"
                                    [hasFleetManagementPermission]="hasFleetManagementPermission"
                                    [hasPricePlanPermission]="hasPricePlanPermission"
                                    [siteDistanceLargeUnit]="siteDistanceLargeUnit"
                                    [hideActions]="hideActions"
                                    [configZoneId]="configZoneId"
                                    (toggleEvent)="toggleDelivery($event.serviceId, $event.event)"
                                    (filterByTypeEvent)="onFilterByType($event)"
                                    (editAddressEvent)="editAddressEvent.emit($event)">

            </app-services-table-row>
          </ng-container>
          <ng-template #itemsContainer class="flex layout-column">
            <app-services-table-item *cdkVirtualFor="let service of services; trackBy: trackById"
                                     class="item flex layout-column"
                                     [service]="service"
                                     [isSelected]="selectedKeys[service.id]"
                                     (toggleEvent)="toggleDelivery($event.serviceId, $event.event)">

            </app-services-table-item>
          </ng-template>

        </cdk-virtual-scroll-viewport>
      </div>
    </div>

  </div>

  <!--Empty State-->
  <div *ngIf="!!isInitialized && !services.length"
       class="flex-100 full-height layout-row layout-align-center-center overflow-auto fade-element-in-only">
    <app-empty-state src="assets/images/empty_state/empty_state_location_box.svg"
                     text="No services found">

    </app-empty-state>
  </div>
</div>

